import { render } from "./InputGuarantee.vue?vue&type=template&id=5dd4f0ce"
import script from "./InputGuarantee.vue?vue&type=script&lang=js"
export * from "./InputGuarantee.vue?vue&type=script&lang=js"
script.render = render

export default script